(() => {
  const QUANTITY_LABELS = {
    en: 'Quantity',
    es: 'Cantidad',
    pt: 'Quantidade',
    fr: 'Quantité',
    de: 'Menge',
    it: 'Quantità',
    nl: 'Aantal'
  };

  const getActiveLanguage = () => {
    const htmlLanguage = document.documentElement.getAttribute('lang') || '';
    const shopifyLanguage = window.Shopify && window.Shopify.locale ? window.Shopify.locale : '';
    const locale = htmlLanguage || shopifyLanguage || 'en';
    return locale.toLowerCase().split('-')[0];
  };

  const localizeQuantityLabels = (root = document) => {
    const language = getActiveLanguage();
    const label = QUANTITY_LABELS[language];
    if (!label) return;

    root.querySelectorAll('[data-quantity-localized-label]').forEach((element) => {
      element.textContent = label;
    });

    root.querySelectorAll('[data-quantity-localized-control]').forEach((element) => {
      element.setAttribute('aria-label', label);
    });
  };

  if (!customElements.get('quantity-dropdown')) {
    class QuantityDropdown extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select[name="quantity"]');
        if (!this.select) return;

        this.syncOptions();
        localizeQuantityLabels(this.closest('[id^="MainProduct-"]') || document);

        this.observer = new MutationObserver((mutations) => {
          if (mutations.some((mutation) => mutation.type === 'attributes')) {
            this.syncOptions();
          }
        });

        this.observer.observe(this.select, {
          attributes: true,
          attributeFilter: ['data-min', 'data-max', 'data-cart-quantity', 'step']
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      syncOptions() {
        const currentValue = Number.parseInt(this.select.value, 10);
        const minimum = Number.parseInt(this.select.dataset.min || '1', 10) || 1;
        const step = Number.parseInt(this.select.getAttribute('step') || '1', 10) || 1;
        const cartQuantity = Number.parseInt(this.select.dataset.cartQuantity || '0', 10) || 0;
        const rawMaximum = this.select.dataset.max ? Number.parseInt(this.select.dataset.max, 10) : null;
        const optionCount = Number.parseInt(this.dataset.optionCount || '10', 10) || 10;
        const maximum = Number.isFinite(rawMaximum) ? Math.max(rawMaximum - cartQuantity, 0) : null;

        // ProductInfo in this theme expects min/max/step properties on the quantity control.
        // Native selects do not expose them, so keep compatible properties available.
        this.select.min = minimum;
        this.select.step = step;
        this.select.max = maximum === null ? '' : maximum;

        const values = [];
        for (let index = 0; index < optionCount; index += 1) {
          const quantity = minimum + (index * step);
          if (maximum !== null && quantity > maximum) break;
          values.push(quantity);
        }

        if (!values.length) values.push(minimum);

        const fragment = document.createDocumentFragment();
        values.forEach((quantity) => {
          const option = document.createElement('option');
          option.value = String(quantity);
          option.textContent = String(quantity);
          fragment.appendChild(option);
        });

        this.select.replaceChildren(fragment);
        this.select.value = values.includes(currentValue) ? String(currentValue) : String(values[0]);
      }
    }

    customElements.define('quantity-dropdown', QuantityDropdown);
  }

  const initLocalization = () => localizeQuantityLabels(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLocalization, { once: true });
  } else {
    initLocalization();
  }

  document.addEventListener('shopify:section:load', (event) => {
    localizeQuantityLabels(event.target || document);
  });

  // Some translation apps update <html lang> without a full page navigation.
  // Watch that attribute so the quantity label follows the language visible to the shopper.
  const languageObserver = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.attributeName === 'lang')) {
      localizeQuantityLabels(document);
    }
  });

  languageObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['lang']
  });
})();
